/**
 * 检查指定DOM元素下的组件是否有修改
 * @param dom DOM元素或元素ID
 * @returns 是否有修改
 */
export function isModified(dom: string | HTMLElement): boolean {
	let nodes: NodeListOf<Element> | undefined

	if (typeof dom === 'string') {
		const element = document.getElementById(dom)
		if (!element) return false
		nodes = element.querySelectorAll('.to-compare')
	} else if (dom instanceof HTMLElement) {
		nodes = dom.querySelectorAll('.to-compare')
	} else {
		return false
	}

	if (!nodes || nodes.length === 0) return false

	// 使用 Vue 3 兼容的方式访问组件实例
	for (let i = 0; i < nodes.length; i++) {
		const node = nodes[i] as Element

		// 检查组件是否有修改
		// 尝试通过 Vue 3 的方式获取组件实例
		if ('__vueParentComponent' in node) {
			const componentInstance = (node as any).__vueParentComponent
			if (componentInstance && componentInstance.exposed?.changed.value) {
				return true
			}
		}
		// 如果是 Vue 组件挂载的根元素
		else if (node instanceof HTMLElement) {
			// 查找组件实例
			const vueInstance = (node as any)._vnode?.ctx
			if (vueInstance && vueInstance.exposed?.changed.value) {
				return true
			}
		}
	}

	return false
}

// 兼容默认导出
export default isModified
